import React, { useState } from "react";
import styles from "../../../views/ReportView/ReportView.module.css";
import IconAnimation from "../../iconAnimation/iconAnimation";
import NotReportViewData from "../../NotReportViewData/NotReportView";
import { GiRelationshipBounds } from "react-icons/gi";

const RelationshipWithMutual = ({ data }) => {
  const [user, setUser] = useState(data);
  const [isEditing] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setUser({ ...user, [name]: value });
  };

  return (
    <div className={styles.LealtadinformacionPolitica} id="relacion">
      <div className={styles.LealtadsectionTitle2}>
        <h2 className={styles.LealtadsectionTitleH2}>Relación con la Mutual</h2>
        <IconAnimation />
      </div>
      {!user || !user.RelationshipWithMutual ? (
        <NotReportViewData
          title="Relación con la mutual"
          Icon={GiRelationshipBounds}
        />
      ) : (
        <>
          <label className={styles.LealtadinputLabel}>
            Relación:
            <select
              className={styles.LealtadinputField}
              name="relation"
              value={user.RelationshipWithMutual.relation}
              disabled={!isEditing}
            >
              <option value="Socio">Socio</option>
              <option value="Proveedor">Proveedor</option>
              <option value="Fondista">Fondista</option>
            </select>
          </label>
          <label className={styles.LealtadinputLabel}>
            Canal:
            <input
              className={styles.LealtadinputField}
              name="canal"
              value={user.RelationshipWithMutual.canal}
              disabled={!isEditing}
            />
          </label>
          {user.RelationshipWithMutual.relation === "Socio" && (
            <>
              <label className={styles.LealtadinputLabel}>
                Fecha de crédito:
                <input
                  className={styles.LealtadinputField}
                  type="date"
                  name="creditDate"
                  value={user.RelationshipWithMutual.creditDate || ""}
                  onChange={handleInputChange}
                  readOnly={!isEditing}
                />
              </label>
              <label className={styles.LealtadinputLabel}>
                Tipo de crédito:
                <select
                  className={styles.LealtadinputField}
                  name="typeOfCredit"
                  value={
                    user.RelationshipWithMutual.typeOfCredit ||
                    "Crédito de consumo"
                  }
                  onChange={handleInputChange}
                  disabled={!isEditing}
                >
                  <option value="Crédito de consumo">Crédito de consumo</option>
                </select>
              </label>
              <label className={styles.LealtadinputLabel}>
                Monto de crédito:
                <input
                  className={styles.LealtadinputField}
                  type="number"
                  name="amountOfCredit"
                  value={user.RelationshipWithMutual.amountOfCredit || ""}
                  onChange={handleInputChange}
                  readOnly={!isEditing}
                />
              </label>
              <label className={styles.LealtadinputLabel}>
                Cantidad de cuotas:
                <input
                  className={styles.LealtadinputField}
                  type="number"
                  name="amountOfFees"
                  value={user.RelationshipWithMutual.amountOfFees || ""}
                  onChange={handleInputChange}
                  readOnly={!isEditing}
                />
              </label>
              <label className={styles.LealtadinputLabel}>
                Monto de la cuota:
                <input
                  className={styles.LealtadinputField}
                  type="number"
                  name="installmentAmount"
                  value={user.RelationshipWithMutual.installmentAmount || ""}
                  onChange={handleInputChange}
                  readOnly={!isEditing}
                />
              </label>
              <label className={styles.LealtadinputLabel}>
                Entidad de Prestamo:
                <input
                  className={styles.LealtadinputField}
                  type="text"
                  name="loanBank"
                  value={user.RelationshipWithMutual.loanBank || ""}
                  onChange={handleInputChange}
                  readOnly={!isEditing}
                />
              </label>
              <label className={styles.LealtadinputLabel}>
                Afiliado:
                <input
                  className={styles.LealtadinputField}
                  type="text"
                  name="affiliate"
                  value={user.RelationshipWithMutual.affiliate || ""}
                  onChange={handleInputChange}
                  readOnly={!isEditing}
                />
              </label>
              <label className={styles.LealtadinputLabel}>
                Crédito:
                <input
                  className={styles.LealtadinputField}
                  type="text"
                  name="credit"
                  value={user.RelationshipWithMutual.credit || ""}
                  onChange={handleInputChange}
                  readOnly={!isEditing}
                />
              </label>
            </>
          )}
        </>
      )}
    </div>
  );
};

export default RelationshipWithMutual;
